import moment from 'moment';
import timezone from 'moment-timezone';

import 'moment/min/locales.min';

moment.locale(process.env.REACT_APP_CURRENT_LANGUAGE, {
  week: {
    dow: 0,
    doy: 0
  }
});

const TIME_ZONE = process.env.REACT_APP_TIME_ZONE || 'America/Argentina/Buenos_Aires';
const DIFF_FORMAT = {
  DAYS: 'days'
};
export const DATE_FORMAT = {
  DATE: 'DD/MM/YYYY',
  TIME: 'HH:mm',
  TIME_MS: 'HH:mm:ss.SSS',
  DATE_TIME: 'DD/MM/YYYY, HH:mm',
  INPUT_FORM_DATE: 'YYYY-MM-DD',
  VALIDATION_FORM_DATE: 'yyyy-mm-dd',
  DATE_WITHOUT_YEAR: 'DD/MM',
  DAY: 'DD',
  MONTH_WITHOUT_YEAR: 'MM/YYYY'
};

export const getDateType = (dateTime?) => moment.utc(dateTime).toDate();
export const getMonths = () => moment.months();
export const getNow = () => moment.utc().format();
export const addYear = (dateTime, number) =>
  moment
    .utc(dateTime)
    .add(number, 'year')
    .format();
export const subtractYear = (dateTime, number) =>
  moment
    .utc(dateTime)
    .subtract(number, 'year')
    .format();
export const addMonth = (dateTime, number) =>
  moment
    .utc(dateTime)
    .add(number, 'month')
    .format();
export const subtractMonth = (dateTime, number) =>
  moment
    .utc(dateTime)
    .subtract(number, 'month')
    .format();
export const getStartOfMonth = (dateTime, format = DATE_FORMAT.INPUT_FORM_DATE) =>
  moment
    .utc(dateTime)
    .startOf('month')
    .format(format);
export const getEndOfMonth = (dateTime, format = DATE_FORMAT.INPUT_FORM_DATE) =>
  moment
    .utc(dateTime)
    .endOf('month')
    .format(format);
export const getYear = dateTime => moment.utc(dateTime).year();
export const getMonth = dateTime => moment.utc(dateTime).month();
export const getStringMonthWithYear = dateTime =>
  `${moment.months(moment(dateTime).months())} ${moment(dateTime).years()}`;
export const getSelectedMonth = (dateTime, month) =>
  moment
    .utc(dateTime)
    .month(month)
    .format();
export const getDate = (dateTime, format = DATE_FORMAT.DATE) => moment.utc(dateTime).format(format);
export const getDateTimezone = (dateTime, format = DATE_FORMAT.DATE) =>
  timezone.tz(dateTime, TIME_ZONE).format(format);
export const getTimeTimezone = (dateTime, format = DATE_FORMAT.TIME) =>
  timezone.tz(dateTime, TIME_ZONE).format(format);
export const getDateTimeTimezone = (dateTime, format = DATE_FORMAT.DATE_TIME) =>
  timezone.tz(dateTime, TIME_ZONE).format(format);
export const dateTimeIsAfter = (beforeDateTime, afterDateTime) =>
  moment(afterDateTime).isAfter(beforeDateTime);
export const dateDifference = (compareDate, currentDate = moment(), format?) =>
  moment(compareDate).diff(currentDate, format || DIFF_FORMAT.DAYS);
export const getManyDate = ({ startMoment }, i, events) => {
  let mappedDate = '';
  const currentSessionMonth = getDate(startMoment, DATE_FORMAT.MONTH_WITHOUT_YEAR);
  const nextSessionMonth = events[i + 1]
    ? getDate(events[i + 1].startMoment, DATE_FORMAT.MONTH_WITHOUT_YEAR)
    : null;
  if (currentSessionMonth === nextSessionMonth) {
    mappedDate = `${getDate(startMoment, DATE_FORMAT.DAY)}, `;
  } else if (events.length - 1 === i) {
    mappedDate = getDate(startMoment);
  } else {
    mappedDate = `${getDate(startMoment, DATE_FORMAT.DATE_WITHOUT_YEAR)}, `;
  }
  return mappedDate;
};
